import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/articles';

const articleListSchema = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: '糖果资讯 - 愽彩糖果',
  description: '愽彩糖果资讯中心，提供糖果选购指南、糖果知识、糖果文化和糖果创意等精彩内容。',
  url: 'https://bocaicandy.com/articles',
};

export default function ArticlesPage() {
  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(articleListSchema)}</script>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '糖果资讯' },
              ]}
            />
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
                糖果资讯
              </h1>
              <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
                甜蜜知识、选购攻略、糖果文化，发现糖果世界的更多精彩
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {articles.map((article) => (
                <ArticleCard
                  key={article.id}
                  slug={article.slug}
                  title={article.title}
                  excerpt={article.excerpt}
                  image={article.image}
                  category={article.category}
                  date={article.date}
                  readTime={article.readTime}
                />
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}